module.exports = __webpack_public_path__ + "4f35f18ae4fb6ba613912a12b8f9abe7.svg";